import React from 'react'
import PropTypes from 'prop-types'
import LocusGroupList from './LocusGroupList'
import LocusGroupForm from './LocusGroupForm'

function LocusGroup(props) {
  const {
    match: {
      params: { id },
    },
  } = props
  const LocusGroupContent = id ? LocusGroupForm : LocusGroupList

  return (
    <div className="content">
      <LocusGroupContent {...props} />
    </div>
  )
}

LocusGroup.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
}

export default LocusGroup
